import { httpCreate } from './http';

const http = httpCreate('/srv/sms-consume-record');

export const smsConsumeRecord = {
	getById(activityId) {
		return http.get(`/${activityId}`);
	},
	getByGatherId(gatherId) {
		return http.get(`/gather/${gatherId}`);
	},
};
